import { useLocalObservable } from "mobx-react";
import React, { createContext, ReactNode } from "react";
import { NoticeDefinitionApi } from "../../api-client";
import { AuthContext } from "../Auth/auth.provider";
import useStore from "../../helpers/useStore";
import { createApiConfig } from "../../api/createApiConfig";

import { UserContext } from "../User/User.provider";
import NoticeStore from "./noticeStore";

interface NoticeDefinitionProviderProps {
  children: ReactNode;
}

export const NoticeContext = createContext<NoticeStore | null>(null);
NoticeContext.displayName = "NoticeContext";

export const NoitceProvider = ({ children }: NoticeDefinitionProviderProps) => {
  const AuthenticationStore = useStore(AuthContext);
  const userStore = useStore(UserContext); // Use UserContext

  const apiClient = new NoticeDefinitionApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(() => new NoticeStore(apiClient, userStore, AuthenticationStore));

  store.apiClient = apiClient;
  // store.getCancelledAppointments().then((res) => { console.log("CancelledAppointmentsdfsf:"); });

  return <NoticeContext.Provider value={store}>{children}</NoticeContext.Provider>;
};
